var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog202(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_202"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_202",
    "data-name": 202,
    className: "cls-2",
    d: "M33.57,6.8C44.23-2.57,64.84,2.53,72.66,16.88c6.26,11.48,2.3,25.17-.92,36.34C66,73.16,50.93,100.57,39.13,97.85c-13.07-3-16-41.59-14.12-64C25.94,22.6,26.89,12.67,33.57,6.8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog202);
export default __webpack_public_path__ + "static/media/dog_202.3a66494b33c6834285a24e6c4618a944.svg";
export { ForwardRef as ReactComponent };